import { render, staticRenderFns } from "./BoardDetailComponent.vue?vue&type=template&id=1b29d2f9&scoped=true"
import script from "./BoardDetailComponent.vue?vue&type=script&lang=js"
export * from "./BoardDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b29d2f9",
  null
  
)

export default component.exports